import TipCalculator from "./features/tipCalculator";

function App() {
  return (
    <TipCalculator/>
  );
}

export default App;
